const Header = ( {title} ) => {
    return (
        <div className="header">
        
          <div className="container-text-header">
            
            <h1>{ title }</h1>
          </div>
        
        </div>
    )
}

export default Header
